window.NPS = window.NPS || {};
window.NPS.Views = window.NPS.Views || {};
window.NPS.Views.LinkEdit = window.NPS.Views.LinkEdit || {};
window.NPS.Views.LinkEdit.Views = window.NPS.Views.LinkEdit.Views || {};
window.NPS.Views.LinkEdit.Views.parameters = (function($, _) {

    function view(editor, opts) {
        var
            self = this,
            opts = _.defaults({}, opts)
        ;
        this.editor = editor;
        this.$el = editor.$el;

        this.link = editor.link;
    }

    view.prototype.$ = function (sp) {
        return this.$el.find(sp);
    };

    view.prototype.stage = function () {
        var self = this;

        self.$el.on('click.npseditorlinksParameters', '[data-page="parameters"] [name="openMode"]', function() {
            self.$('.openMode-details').hide();
            self.$('#options_'+this.value).show();
        });

        return this;
    };
    view.prototype.unstage = function () {
        this.$el.off('.npseditorlinksParameters');
        return this;
    };

    view.prototype.commit = function () {
        var self = this,
            mode = self.$('input[name="openMode"]:checked').attr('value'),
            $modeElement = self.$('#mode_'+mode),
            $optionsElement = self.$('#options_'+mode),
            attrn = $modeElement.attr('data-attribute'),
            optionsInfo = {};

        if ($optionsElement.length) {
            $optionsElement.find('div[optionName]').each(function() {
                var $opt = $(this),
                    name = $opt.attr('optionName'),
                    fied = 'opt_'+mode+'_'+name,
                    fnApply;

                switch ($opt.attr('optionType')) {
                    case 'integer' : fnApply = function fnRedeemIntegerOption(field, defaultValue) {
                                var oInput = document.getElementById(field), min, max;
                                if (!oInput) return defaultValue;

                                var value = parseInt(oInput.value, 10);
                                if (isNaN(value)) return defaultValue;

                                min = oInput.getAttribute('minimumValue');
                                max = oInput.getAttribute('maximumValue');

                                if ((min!=="")&&(value<parseInt(min, 10)))
                                    return min;
                                if ((max!=="")&&(value>parseInt(max, 10)))
                                    return max;

                                return value;
                            };
                        break;
                    case 'text' : fnApply = function fnRedeemTextOption(field) {
                                var $input = self.$('#'+field);
                                return ($input.length) ? $input.val() : "";
                            };
                        break;
                    case 'radio' :  fnApply = function fnRedeemRadioOption(field, defaultValue) {
                                var rd = self.$('input[name="'+field+'"]:checked');
                                return (rd.length) ? rd.attr('value') : defaultValue;
                            };
                        break;
                    case 'select' :  fnApply = function fnRedeemSelectOption(field, defaultValue) {
                                var $select = self.$('#'+field);
                                return ($select.length) ? $select.val() : defaultValue;
                            };
                        break;
                    case 'hidden' :  fnApply = function fnRedeemHiddenOption(field, defaultValue) {
                                var $input = self.$('#'+field);
                                if (!$input.length) return defaultValue;

                                return self.editor.interpolate($input.attr('value'));
                            };
                        break;
                }
                if (!fnApply) return this;

                optionsInfo[name] = fnApply(fied, self.editor.interpolate($opt.attr('optionDefault')));
                if ($opt.attr('optionAttr')==='yes') {
                    self.link.setAttribute(name, optionsInfo[name]);
                }

                return this;
            });
        }
        self.link.setOptions(optionsInfo);

        if (attrn) {
            self.link.setAttribute(attrn, JSON.stringify(optionsInfo));
        } else {
            self.link.setProperty('functionCall', $modeElement.attr('jsFunction'));
            self.link.setProperty('scriptmode', $modeElement.attr('scriptmode'));
            self.link.setProperty('target', $modeElement.attr('target'));
        }

        if ((self.$('#edquerystring').length) && (self.$('#edquerystring').val())) {
            self.link.setProperty('querystring', self.$('#edquerystring').val());
        }
    };

    return function(editor, opts) {
        return new view(editor, opts);
    }

})(window.jQuery, window._);